import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const CTASection = ({ 
  title = "Ready to Create Something Extraordinary?",
  subtitle = "Let's bring your vision to life with world-class event management",
  primaryCta = { text: "Get a Quote", link: "/contact-us" },
  secondaryCta = { text: "View Our Services", link: "/services" }
}) => {
  return (
    <section data-testid="cta-section" className="py-16 bg-[#D4AF37]">
      <div className="w-full px-4 sm:px-8 lg:px-16">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="text-center md:text-left">
            <h2 className="font-montserrat text-black text-2xl md:text-3xl lg:text-4xl mb-2">
              {title}
            </h2>
            <p className="font-google-sans text-black/70">
              {subtitle}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <Link
              to={primaryCta.link}
              data-testid="cta-primary"
              className="group bg-black text-white font-medium px-8 py-4 uppercase tracking-widest text-sm hover:bg-black/80 transition-all duration-300 flex items-center gap-3"
            >
              {primaryCta.text}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link
              to={secondaryCta.link}
              data-testid="cta-secondary"
              className="border-2 border-black text-black font-medium px-8 py-4 uppercase tracking-widest text-sm hover:bg-black hover:text-white transition-all duration-300"
            >
              {secondaryCta.text}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
